/*
 * @Author: hehaishen
 * @Date: 2018-12-21 11:06:52
 * @LastEditors: hehaishen
 * @LastEditTime: 2019-09-16 19:38:43
 * @Description: 
 */
const routerArr = [{
        path: 'brandInfomation',
        component: (resolve) => require(["page/operateManagement/index"], resolve),
        meta: { show: '1110', title: '品牌资料', source: '11b8' }
    },
    {
        path: 'addDoc',
        component: (resolve) => require(["page/operateManagement/docAdd"], resolve),
        meta: { show: '1110', title: '新增资料', source: '11b8' }
    },
    {
        path: 'editDoc',
        component: (resolve) => require(["page/operateManagement/docEdit"], resolve),
        meta: { show: '1110', title: '编辑资料', source: '11b8' }
    },
    {
        path: 'brandInfomation/brand',
        component: (resolve) => require(["page/operateManagement/brand"], resolve),
        meta: { show: '1110', title: '品牌名称', source: '11b8' }
    },
    {
        path: 'brandInfomation/brand/brandDetail',
        name: 'brandDetail',
        component: (resolve) => require(["page/operateManagement/brandDetail"], resolve),
        meta: { show: '1110', title: '详情', source: '11b8' }
    },
    {
        path: 'docType',
        component: (resolve) => require(["page/operateManagement/doc"], resolve),
        meta: { show: '1110', title: '资料类型', source: '11b8' }
    },
    {
        path: 'brandManagement',
        component: (resolve) => require(["page/operateManagement/brandMangement"], resolve),
        meta: { show: '1110', title: '品牌管理', source: '11b8' },

    },
    {
        path: 'brandManagement/brandManagementDetail',
        name: 'brandManagementDetail',
        component: (resolve) => require(["page/operateManagement/brandDetail"], resolve),
        meta: { show: '1110', title: '详情', source: '11b8', }
    },
    {
        path: 'faultCode',
        name: 'faultCode',
        component: (resolve) => require(["page/operateManagement/faultCode"], resolve),
        meta: { show: '1110', title: '故障代码', source: '11b8' }
    },
    {
        path: 'faultCode/addEdit',
        name: 'faultCodeAddEdit',
        component: (resolve) => require(["page/operateManagement/faultCode/addEdit"], resolve),
        meta: { show: '1110', title: '故障代码新增编辑', source: '11b8' }
    },
    {
        path: 'faultCode/importCode',
        name: 'faultCodeImportCode',
        component: (resolve) => require(["page/operateManagement/faultCode/faultCodeImport"], resolve),
        meta: { show: '1110', title: '故障代码导入', source: '11b8', }
    },
    {
        path: 'faultSymptom',
        name: 'faultSymptom',
        component: (resolve) => require(["page/operateManagement/faultSymptom/index.vue"], resolve),
        meta: { show: '1110', title: '故障现象', source: '11b8' }
    },
    {
        path: 'manufacturersDevice',
        name: 'manufacturersDevice',
        component: (resolve) => require(["page/operateManagement/manufacturersDevice/index.vue"], resolve),
        meta: { show: '1110', title: '厂商设备', source: '11b8' }
    },
    {
        path: 'faultContrast',
        name: 'faultContrast',
        component: (resolve) => require(["page/operateManagement/faultContrast/index.vue"], resolve),
        meta: { show: '1110', title: '故障对照表', source: '11b8' }
    },
    {
        path: 'faultContrast/yuFaultCodeList',
        name: 'yuFaultCodeList',
        component: (resolve) => require(["page/operateManagement/faultContrast/yuFaultCode/index.vue"], resolve),
        meta: { show: '1110', title: '故障代码表', source: '11b8' }
    },
    {
        path: 'faultContrast/yuFaultCode',
        name: 'yuFaultCode',
        component: (resolve) => require(["page/operateManagement/faultContrast/yuFaultCode/codehandle.vue"], resolve),
        meta: { show: '1110', title: '故障代码操作', source: '11b8' }
    },
    // {
    //     path: 'enterprise/:id',
    //     name: 'enterpriseDetail',
    //     component: (resolve) =>require(["page/enterpriseManagement/detail"], resolve),
    //     meta:{
    //       show: '1110',
    //       title: '详情',
    //       keepAlive: true
    //     }
    //   }
];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/operateManagement/_res.js